/* ===========================================================================
   Catalog card RRP label - strip the VAT wording in zero-rate countries.

   The collection/catalog cards render a small grey line via the B2B app:
       RRP: $230.00 inc. VAT
   An inline script in layout/theme.liquid rewrites the app's default
   "excl. VAT" to "inc. VAT". That is right for markets that actually have a
   rate, but wrong somewhere like Hong Kong, Qatar, Kuwait or the US, where no
   VAT/GST exists at all - the price contains no tax to include.

   This runs after that inline script and removes the VAT wording entirely
   whenever the resolved rate is 0, leaving just "RRP: $230.00".

   Uses the same planoraResolveTaxRate() as the margin table (defined in
   assets/bss-custom.js), so the card and the chart can never disagree.
   =========================================================================== */
(function () {
  var DONE_ATTR = 'planoraVatLabel';

  function resolveRate() {
    if (typeof planoraResolveTaxRate === 'function') {
      return planoraResolveTaxRate().rate;
    }
    // Fallback if the main script has not parsed yet - Shopify's own rate only.
    return Number((window.BSS_B2B && window.BSS_B2B.countryTax) || 0);
  }

  function stripVatWording(el) {
    if (!el || el.dataset[DONE_ATTR]) return;
    var html = el.innerHTML;
    // Remove "inc. VAT", "incl VAT", "excl. VAT", "excluding VAT" and any
    // whitespace or separator immediately before them.
    var cleaned = html.replace(
      /[\s ]*(?:\(|,)?[\s ]*(?:inc|incl|including|exc|excl|excluding)\.?[\s ]*VAT[\s ]*\)?/gi,
      ''
    );
    if (cleaned !== html) {
      el.innerHTML = cleaned;
    }
    el.dataset[DONE_ATTR] = 'true';
  }

  function scan() {
    if (resolveRate() > 0) return; // a real rate applies - leave the label alone
    document.querySelectorAll('.cqb-rrp').forEach(stripVatWording);
  }

  function start() {
    scan();
    var observer = new MutationObserver(function () { scan(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
